import React, { FC } from 'react';
import { AsyncNotificationStatus } from '../../../../../utils/hooks/useNotificator/useNotificator.types';
import { IOuter } from './DataHook.types';

export const DataHook: FC<IOuter> = ({ children, dataHook, notification }) => (
  <span
    data-hook={notification.status === AsyncNotificationStatus.None ? dataHook : `${dataHook}.${notification.status}`}
  >
    {children}
  </span>
);
